import config from '../config/server-config';
import { TokenDecode } from './general-util';
import pathConst from '../constants/PathsConstant';
import numConst from '../constants/NumberConstants';
import api from '../api';
import { FE_ENV } from '../../frontend-env';

// PDF Download
export const getPDFOld = async (res) => {
  try {
    const tokenJSON = await TokenDecode();
    const response = await api.post(
      config.getPDFOld, // URL
      {
        pdfListItems: res.pdfListItems,
        pdfTitle: res.pdfTitle.replaceAll('System (', 'System-('),
        loginUrl: `${window.location.origin}${pathConst.CREDENTIAL_FORM}/`,
        token: localStorage.getItem('token'),
        User_Id: tokenJSON.User_Id !== undefined ? tokenJSON.User_Id : 0,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }, // Data
      { cancelToken: res.signal },
    );
    if (response.status === numConst.API_CALL_SUCCESSFULL) {
      if (response.data !== undefined && response.data.FilePath !== '') {
        res.setConfirmPDFTitle(res.pdfTitle);
        return {
          pdfstatus: true,
          pdffileURL: response.data.FilePath,
          error: response.data.errorMsg,
        };
      }
      return {
        pdfstatus: false,
        pdffileURL: response.data.FilePath,
        error: response.data.errorMsg,
      };
    }
    return { pdfstatus: false, pdffileURL: '', error: '' };
  } catch (err) {
    return { pdfstatus: false, pdffileURL: '', error: '' };
  }
};

/**
 * @param {string[]} documents
 * @param {string} pid
 * @param {string} origin
 * @returns {Promise<{data: any, status: number}>}
 */
export async function getPDFLambda(documents, pid, origin, timeZone, extraParams) {
  return api.post('/api/v2/pdf/getPDF', { documents, pid, origin, timeZone, extraParams });
}

/**
 * @typedef {object} PdfStatus
 * @property {number} id
 * @property {string} pdfPath
 * @property {'idle'|'pending'|'success'|'error'} status
 */

/**
 * @param {number} pdfId
 * @returns {Promise<PdfStatus>}
 */
export async function getPdfStatus(pdfId) {
  const result = await api.post('/api/v2/pdf/getPDFStatus', { pdfId });
  return result.data;
}

/**
 * Kicks off async stewardship PDF generation via the v1 company endpoint.
 * @param {number} pid
 * @param {number} [meetingId]
 * @param {string} timeZone
 * @returns {Promise<{data: {pdfId: number}, status: number}>}
 */
export async function getStewardshipPdf(pid, meetingId, timeZone) {
  return api.post(config.stewardshipPdf, { pid, meetingId, timeZone });
}

export const getPDF = async (res) => {
  try {
    const tokenJSON = await TokenDecode();
    const response = await api.post(
      config.getPDF, // URL
      {
        pdfListItems: res.pdfListItems,
        pdfTitle: res.pdfTitle.replaceAll('System (', 'System-('),
        loginUrl: `${window.location.origin}${
          FE_ENV.REACT_APP_IS_NATIVE_AWS === 'true' ? pathConst.SERVERSIDE_CALLBACK : pathConst.CREDENTIAL_FORM
        }/`,
        token: localStorage.getItem('token'),
        User_Id: tokenJSON.User_Id !== undefined ? tokenJSON.User_Id : 0,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      }, // Data
      { cancelToken: res.signal },
    );
    if (response.status === numConst.API_CALL_SUCCESSFULL) {
      if (response.data !== undefined && response.data.FilePath !== '') {
        res.setConfirmPDFTitle(res.pdfTitle);
        return {
          pdfstatus: true,
          pdffileURL: response.data.FilePath,
          error: response.data.errorMsg,
        };
      }
      return {
        pdfstatus: false,
        pdffileURL: response.data.FilePath,
        error: response.data.errorMsg,
      };
    }
    return { pdfstatus: false, pdffileURL: '', error: '' };
  } catch (err) {
    return { pdfstatus: false, pdffileURL: '', error: '' };
  }
};
export const getPDFClose = async () => {
  try {
    const response = await api.post(config.getPDFClose);
    if (response.status === numConst.API_CALL_SUCCESSFULL) {
      return {
        pdfstatus: false,
        pdffileURL: response.data.data,
        error: response.data.errorMsg,
      };
    }
  } catch (err) {
    if (err?.name === 'AbortError') {
      return { pdfstatus: false, pdffileURL: '', error: '' };
    }
  }
};

// Recent Downloads
export const getDataRecentDownloadList = async () => {
  try {
    let uid;
    await TokenDecode()
      .then((res) => {
        uid = res.User_Id;
      })
      .catch((e) => new Error(e));

    const response = await api.post(config.getRecentDownloadList, {
      user_id: uid,
    });
    if (response.status === numConst.API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};

export const getPDFUrl = async (pdfName) => {
  try {
    let uid;
    await TokenDecode()
      .then((res) => {
        uid = res.User_Id;
      })
      .catch((e) => new Error(e));
    const response = await api.post(config.getPDFUrl, {
      user_id: uid,
      pdf_name: pdfName,
    });
    if (response.status === numConst.API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    return false;
  }
};
